import React from 'react';

export const reorderFilterIcon = (
  <svg width="16" height="16" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.33366 14.01V7H7.66699V14.01H5.16699L8.50033 18L11.8337 14.01H9.33366ZM3.50033 0L0.166992 3.99H2.66699V11H4.33366V3.99H6.83366L3.50033 0ZM9.33366 14.01V7H7.66699V14.01H5.16699L8.50033 18L11.8337 14.01H9.33366ZM3.50033 0L0.166992 3.99H2.66699V11H4.33366V3.99H6.83366L3.50033 0Z"
      fill="#333333"
    />
  </svg>
);
